import { search } from 'sr-types';
import { FILTER_IDENTIFIERS } from '../constants/constants';
import { FEATURE_CONSTANTS } from '../constants/featureConstants';
import { SavePreferenceFormData } from './savePreference';

export interface SavedFilter {
    id: string;
    name: string;
    entity: string;
    filters: Filter[];
    createdOn: string;
    description?: string;
}

export interface Filter {
    identifier: string;
    value?: unknown;
    dateMin?: string;
    dateMax?: string;
}

export interface SavedFilterShareData {
    sharedWithOrganizationAccounts: {
        actor: {
            id: string;
            name: string;
            email: string;
        };
        action: string;
    };
}

export interface SavedFilterModalProps {
    open: boolean;
    onClose: () => void;
    onSave: (data: SavePreferenceFormData) => Promise<void>;
    appliedFilters: Filter[];
    isLoading?: boolean;
    facets?: search.SkFacetSet[];
    isEdit?: boolean;
    initialData?: SavePreferenceFormData;
}

export interface SavedFilterChipProps {
    filterName: string;
    onClear: () => void;
    hasUnsavedChanges?: boolean;
}

export interface UseSavedFiltersProps {
    entity: string;
    activeOrganizationAccount: string;
    userProfile: {
        id: string;
        name: string;
        email: string;
        accountId: string;
    };
}

export interface UseSavedFiltersReturn {
    savedFilters: SavedFilter[];
    saveFilter: (data: SavePreferenceFormData, filters: Filter[]) => Promise<void>;
    applySavedFilter: (preferenceId: string) => void;
    clearAppliedSavedFilter: () => void;
    isLoading: boolean;
}

export const SAVED_FILTERS_CONSTANTS = {
    STORAGE_KEY_PREFIX: 'saved_filters_',
    SELECTED_KEY_PREFIX: 'selected_saved_filter_',
    FILTER_ID_PREFIX: 'filter_',
    PINNED_TABS_PREFERENCE_NAME: 'Pinned Filter Tabs',
    PINNED_TAB_DRAG_HANDLE_CLASS: 'pinned-tab-drag-handle',
    PINNED_TAB_UNPIN_BUTTON_CLASS: 'pinned-tab-unpin-button',
    EXCLUDED_FILTERS: [
        FILTER_IDENTIFIERS.entity,
        FILTER_IDENTIFIERS.public,
        FILTER_IDENTIFIERS.managedProduction,
        FILTER_IDENTIFIERS.owned,
        FILTER_IDENTIFIERS.state,
        FILTER_IDENTIFIERS.origin,
        FILTER_IDENTIFIERS.allProductionsExceptPipeline,
        FILTER_IDENTIFIERS.entityType,
        FILTER_IDENTIFIERS.excludeOwnedBranchedProductions
    ],
    SHARE_DEFAULTS: {
        SHARED_WITH_ORGANIZATION_ACCOUNTS: {
            action: 'View'
        }
    }
};

export const SAVED_FILTERS_KEY_ENTITY_BY_FEATURE = {
    [FEATURE_CONSTANTS.productionWorkspace]: 'Workspace'
};

export type SavedFilterPreferenceValue = {
    filters: Filter[];
    /** Legacy only — pins live in PinnedSavedFiltersPreferenceValue */
    pinAsTab?: boolean;
    pinnedAt?: string;
};

export type PinnedSavedFilterTab = {
    preferenceId: string;
    pinnedAt: string;
};

export type PinnedSavedFiltersPreferenceValue = {
    schemaVersion: 1;
    /** When true, `pinnedTabs` array order is the display source of truth. */
    manualOrder?: boolean;
    pinnedTabs: PinnedSavedFilterTab[];
};

export type SavedFilterItem = {
    name: string;
    filters: Filter[];
    shared: boolean;
    id?: string;
    description?: string;
    accountId?: string;
    pinAsTab?: boolean;
    pinnedAt?: string;
    security?: {
        allowedActions?: string[];
    };
};

export type SelectedSavedFilter = {
    preferenceId: string;
    filters?: Filter[];
};
